import React, {useState, useEffect} from 'react';
import {useLocation} from 'react-router-dom';

import {text} from '../text';
import {hooks} from '../hooks';
import {utils} from '../utils';
import {svg} from '../assets/svg';
import {theme} from '../constants';
import {components} from '../components';
import {clearAuth} from '../store/slices/authSlice';
import {authService} from '../services/authService';
import { listCache } from '../utils/listCache';
import { useLanguage } from '../context/LanguageContext';
import axiosInstance from '../services/axiosInstance';
import { MdPerson, MdMusicNote, MdTab } from 'react-icons/md';
import { useUiPreferences, TaskDetailLayout } from '../context/UiPreferencesContext';
import { RINGTONES, getRingtoneKey, setRingtoneKey } from '../constants/ringtones';

const PersonIcon = MdPerson as any;
const MusicNoteIcon = MdMusicNote as any;
const TabIcon = MdTab as any;

export const Profile: React.FC = () => {
  const {pathname} = useLocation();

  const navigate = hooks.useAppNavigate();
  const dispatch = hooks.useAppDispatch();
  const authSlice = hooks.useAppSelector((state) => state.authSlice);
  const { t, language, setLanguage, availableLanguages } = useLanguage();
  const { taskDetailLayout, setTaskDetailLayout } = useUiPreferences();

  const [faceID, setFaceID] = useState(true);
  const [notification, setNotification] = useState(true);
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const [showLanguageModal, setShowLanguageModal] = useState(false);
  const [showRingtoneModal, setShowRingtoneModal] = useState(false);
  const [showLayoutModal, setShowLayoutModal] = useState(false);
  const [selectedRingtone, setSelectedRingtone] = useState(getRingtoneKey);
  const previewAudioRef = React.useRef<HTMLAudioElement | null>(null);
  const [employee, setEmployee] = useState<any>(null);
  const imageBaseUrl = process.env.REACT_APP_IMAGE_BASE_URL || 'https://apiteratasks.teralintas.com/';

  useEffect(() => {
    setTimeout(() => {
      window.scroll({top: -1, left: 0, behavior: 'smooth'});
    }, 10);
  }, [pathname]);

  useEffect(() => {
    const fetchEmployeeData = async () => {
      try {
        const response = await axiosInstance.get('/employees/profile');
        setEmployee(response.data);
      } catch (error) {
        console.error("Failed to fetch employee data", error);
      }
    };
    fetchEmployeeData();
  }, []);

  const renderHeader = (): JSX.Element => {
    return (
      <components.Header
        title={t.profile.title}
        goBack={true}
      />
    );
  };

  const renderUserInfo = (): JSX.Element => {
    return (
      <div
        style={{marginBottom: 30, cursor: 'pointer', userSelect: 'none'}}
        onClick={() => navigate('/EditPersonalInfo')}
      >
        <div
          style={{
            width: 100,
            height: 100,
            borderRadius: 50,
            margin: '0 auto',
            marginBottom: 14,
            backgroundColor: '#F3F4F6',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            overflow: 'hidden',
            border: `3px solid ${theme.colors.mainColor}`
          }}
        >
          {employee?.photo ? (
            <img src={`${imageBaseUrl}${employee.photo}`} alt="profile" style={{width: '100%', height: '100%', objectFit: 'cover'}} />
          ) : (
            <img src="/images/logo.png" alt="profile" style={{width: '100%', height: '100%', objectFit: 'cover'}} />
          )}
        </div>
        <text.H4 style={{textAlign: 'center'}}>{authSlice.userName || 'User'}</text.H4>
        <text.T16 style={{textAlign: 'center'}}>{authSlice.email || 'No email'}</text.T16>
      </div>
    );
  };

  const renderMenu = (): JSX.Element => {
    const btnStyle = {
      borderRadius: 10,
      backgroundColor: '#FFF7F2',
      padding: '10px 20px 10px 10px',
      ...utils.rowCenter(),
    };

    return (
      <div style={{marginBottom: 30, display: 'flex', flexDirection: 'column', gap: 8}}>
        <div
          style={{
            ...btnStyle,
            cursor: 'pointer',
            userSelect: 'none',
          }}
          onClick={() => navigate('/EditPersonalInfo')}
        >
          <svg.ProfileUserSvg />
          <text.H5 style={{marginLeft: 10, marginRight: 'auto'}}>
            {t.profile.personalInfo}
          </text.H5>
          <svg.RightArrowSvg />
        </div>
        {/* <div
          style={{
            ...btnStyle,
            cursor: 'pointer',
            userSelect: 'none',
          }}
          onClick={() => setNotification(!notification)}
        >
          <svg.MessageCircelSvg />
          <text.H5 style={{marginLeft: 10, marginRight: 'auto'}}>
            Notifications
          </text.H5>
          <div
            style={{
              width: 41,
              backgroundColor: notification ? '#55ACEE' : 'lightgray',
              borderRadius: 12,
              padding: '1.5px 1.5px',
              cursor: 'pointer',
              userSelect: 'none',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: notification ? 'flex-end' : 'flex-start',
            }}
          >
            <div
              style={{
                width: 20.9,
                height: 20.9,
                backgroundColor: '#FFFFFF',
                borderRadius: 11,
                alignSelf: notification ? 'flex-end' : 'flex-start',
              }}
            />
          </div>
        </div>
        <div
          style={{
            ...btnStyle,
            marginBottom: 10,
            cursor: 'pointer',
            userSelect: 'none',
          }}
          onClick={() => setFaceID(!faceID)}
        >
          <svg.FaceIDSvg />
          <text.H5 style={{marginLeft: 10, marginRight: 'auto'}}>
            Face ID
          </text.H5>
          <div
            style={{
              width: 41,
              backgroundColor: faceID ? '#55ACEE' : 'lightgray',
              borderRadius: 12,
              padding: '1.5px 1.5px',
              cursor: 'pointer',
              userSelect: 'none',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: faceID ? 'flex-end' : 'flex-start',
            }}
          >
            <div
              style={{
                width: 20.9,
                height: 20.9,
                backgroundColor: '#FFFFFF',
                borderRadius: 11,
                alignSelf: faceID ? 'flex-end' : 'flex-start',
              }}
            />
          </div>
        </div>
        */}
        <div style={{...btnStyle, cursor: 'pointer', userSelect: 'none'}} onClick={() => setShowLanguageModal(true)}>
          <svg.TranslateSvg />
          <text.H5 style={{marginLeft: 10, marginRight: 'auto'}}>
            {t.profile.language}
          </text.H5>
          <div style={{...utils.rowCenter({gap: 11})}}>
            <span
              style={{
                fontSize: 12,
                color: theme.colors.bodyTextColor,
                ...theme.fonts.SourceSansPro_400Regular,
              }}
            >
              {availableLanguages.find(l => l.code === language)?.name || language.toUpperCase()}
            </span>
            <svg.RightArrowSvg />
          </div>
        </div>
        <div style={{...btnStyle, cursor: 'pointer', userSelect: 'none'}} onClick={() => setShowRingtoneModal(true)}>
          <div style={{width: 40, height: 40, borderRadius: 20, backgroundColor: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0}}>
            <MusicNoteIcon size={16} color='#040325' />
          </div>
          <text.H5 style={{marginLeft: 10, marginRight: 'auto'}}>
            {(t.profile as any).ringtone || 'Ringtone'}
          </text.H5>
          <div style={{...utils.rowCenter({gap: 11})}}>
            <span style={{fontSize: 12, color: theme.colors.bodyTextColor, ...theme.fonts.SourceSansPro_400Regular}}>
              {(() => { const rt = RINGTONES.find(r => r.key === selectedRingtone); return rt ? ((t.profile as any)[rt.labelKey] ?? rt.key) : ''; })()}
            </span>
            <svg.RightArrowSvg />
          </div>
        </div>
        <div style={{...btnStyle, cursor: 'pointer', userSelect: 'none'}} onClick={() => setShowLayoutModal(true)}>
          <div style={{width: 40, height: 40, borderRadius: 20, backgroundColor: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0}}>
            <TabIcon size={16} color='#040325' />
          </div>
          <text.H5 style={{marginLeft: 10, marginRight: 'auto'}}>
            {t.profile.taskDetailLayout}
          </text.H5>
          <div style={{...utils.rowCenter({gap: 11})}}>
            <span style={{fontSize: 12, color: theme.colors.bodyTextColor, ...theme.fonts.SourceSansPro_400Regular}}>
              {taskDetailLayout === 'tabs' ? t.profile.layoutTabs : t.profile.layoutScroll}
            </span>
            <svg.RightArrowSvg />
          </div>
        </div>
      </div>
    );
  };

  const renderButton = (): JSX.Element => {
    const handleLogout = async () => {
      try {
        setIsLoggingOut(true);
        
        // Call logout API (optional)
        try {
          await authService.logout();
        } catch (error) {
          console.log('Logout API call failed, but continuing with cleanup');
        }
        
        // Hapus semua listCache agar data user lama tidak bocor ke user berikutnya
        listCache.clearAll();

        // Clear auth from Redux
        dispatch(clearAuth());

        // Navigate to SignIn page
        navigate('/SignIn');
      } catch (error) {
        console.error('Logout error:', error);
        // Still navigate even if error
        navigate('/SignIn');
      } finally {
        setIsLoggingOut(false);
      }
    };

    return (
      <components.Button
        title={isLoggingOut ? t.profile.loggingOut : t.profile.logout}
        colorScheme='light'
        onClick={handleLogout}
      />
    );
  };

  const renderContent = (): JSX.Element => {
    return (
      <main
        className='container'
        style={{marginTop: 52 + 46, marginBottom: 20}}
      >
        {renderUserInfo()}
        {renderMenu()}
        {renderButton()}
      </main>
    );
  };

  const renderLanguageModal = () => {
    if (!showLanguageModal) return null;
    
    return (
      <div
        style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 2000,
          display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 20
        }}
        onClick={() => setShowLanguageModal(false)}
      >
        <div
          style={{
            backgroundColor: 'white', borderRadius: 16, padding: 24,
            width: '100%', maxWidth: 320,
            boxShadow: '0 10px 25px rgba(0,0,0,0.1)',
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <text.H4 style={{marginBottom: 20}}>{t.profile.selectLanguage}</text.H4>

          {availableLanguages.map((lang, idx) => (
            <div
              key={lang.code}
              onClick={() => { setLanguage(lang.code); setShowLanguageModal(false); }}
              style={{
                padding: '15px 0',
                borderBottom: idx < availableLanguages.length - 1 ? '1px solid #F3F4F6' : 'none',
                display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer'
              }}
            >
              <text.T16 style={{color: language === lang.code ? theme.colors.mainColor : theme.colors.mainDark}}>
                {lang.name}
              </text.T16>
              {language === lang.code && <svg.CheckSvg />}
            </div>
          ))}

          <components.Button
            title={t.common.cancel}
            colorScheme='light'
            containerStyle={{marginTop: 20}}
            onClick={() => setShowLanguageModal(false)}
          />
        </div>
      </div>
    );
  };

  const renderLayoutModal = () => {
    if (!showLayoutModal) return null;
    const options: { value: TaskDetailLayout; label: string; desc: string }[] = [
      { value: 'scroll', label: t.profile.layoutScroll, desc: t.profile.layoutScrollDesc },
      { value: 'tabs', label: t.profile.layoutTabs, desc: t.profile.layoutTabsDesc },
    ];
    return (
      <div
        style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 2000,
          display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 20
        }}
        onClick={() => setShowLayoutModal(false)}
      >
        <div
          style={{
            backgroundColor: 'white', borderRadius: 16, padding: 24,
            width: '100%', maxWidth: 320,
            boxShadow: '0 10px 25px rgba(0,0,0,0.1)',
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <text.H4 style={{marginBottom: 20}}>{t.profile.selectTaskDetailLayout}</text.H4>

          {options.map((opt, idx) => (
            <div
              key={opt.value}
              onClick={() => { setTaskDetailLayout(opt.value); setShowLayoutModal(false); }}
              style={{
                padding: '14px 0',
                borderBottom: idx < options.length - 1 ? '1px solid #F3F4F6' : 'none',
                display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12, cursor: 'pointer'
              }}
            >
              <div>
                <text.T16 style={{color: taskDetailLayout === opt.value ? theme.colors.mainColor : theme.colors.mainDark}}>
                  {opt.label}
                </text.T16>
                <text.T14 style={{fontSize: 12, color: theme.colors.bodyTextColor, marginTop: 2}}>{opt.desc}</text.T14>
              </div>
              {taskDetailLayout === opt.value && <svg.CheckSvg />}
            </div>
          ))}

          <components.Button
            title={t.common.cancel}
            colorScheme='light'
            containerStyle={{marginTop: 20}}
            onClick={() => setShowLayoutModal(false)}
          />
        </div>
      </div>
    );
  };

  const stopPreview = () => {
    if (previewAudioRef.current) { previewAudioRef.current.pause(); previewAudioRef.current = null; }
  };

  const handlePreview = (file: string | null) => {
    stopPreview();
    if (!file) return;
    const audio = new Audio(file);
    audio.volume = 0.7;
    audio.play().catch(() => {});
    previewAudioRef.current = audio;
    setTimeout(stopPreview, 3000);
  };

  const handleSelectRingtone = (key: string, file: string | null) => {
    stopPreview();
    setRingtoneKey(key);
    setSelectedRingtone(key);
    setShowRingtoneModal(false);
    // Brief preview of selected tone
    if (file) {
      const audio = new Audio(file);
      audio.volume = 0.7;
      audio.play().catch(() => {});
      previewAudioRef.current = audio;
      setTimeout(stopPreview, 2000);
    }
  };

  const renderRingtoneModal = () => {
    if (!showRingtoneModal) return null;
    return (
      <div
        style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 2000,
          display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 20,
        }}
        onClick={() => { stopPreview(); setShowRingtoneModal(false); }}
      >
        <div
          style={{
            backgroundColor: 'white', borderRadius: 16, padding: 24,
            width: '100%', maxWidth: 320,
            boxShadow: '0 10px 25px rgba(0,0,0,0.1)',
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <text.H4 style={{marginBottom: 20}}>
            {(t.profile as any).selectRingtone || 'Select Ringtone'}
          </text.H4>

          {RINGTONES.map((rt, idx) => {
            const label = (t.profile as any)[rt.labelKey] ?? rt.key;
            const isSelected = selectedRingtone === rt.key;
            return (
              <div
                key={rt.key}
                style={{
                  padding: '13px 0',
                  borderBottom: idx < RINGTONES.length - 1 ? '1px solid #F3F4F6' : 'none',
                  display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                }}
              >
                <div
                  style={{ display: 'flex', alignItems: 'center', gap: 10, flex: 1, cursor: 'pointer' }}
                  onClick={() => handleSelectRingtone(rt.key, rt.file)}
                >
                  <text.T16 style={{color: isSelected ? theme.colors.mainColor : theme.colors.mainDark}}>
                    {label}
                  </text.T16>
                  {isSelected && <svg.CheckSvg />}
                </div>
                {rt.file && (
                  <button
                    onClick={(e) => { e.stopPropagation(); handlePreview(rt.file); }}
                    style={{
                      border: 'none', background: 'none', padding: '4px 8px',
                      color: theme.colors.mainColor, cursor: 'pointer', fontSize: 12,
                      flexShrink: 0,
                    }}
                  >
                    {(t.profile as any).preview || 'Preview'}
                  </button>
                )}
              </div>
            );
          })}

          <components.Button
            title={t.common.cancel}
            colorScheme='light'
            containerStyle={{marginTop: 20}}
            onClick={() => { stopPreview(); setShowRingtoneModal(false); }}
          />
        </div>
      </div>
    );
  };

  return (
    <div id='screen'>
      {renderHeader()}
      {renderContent()}
      {renderLanguageModal()}
      {renderRingtoneModal()}
      {renderLayoutModal()}
    </div>
  );
};
